export const BOOTSTRAP_BREAKPOINTS = {
  xs: 0, // < 576px
  sm: 576, // ≥ 576px
  md: 768, // ≥ 768px
  lg: 992, // ≥ 992px
  xl: 1200, // ≥ 1200px
  xxl: 1400, // ≥ 1400px
};
